// import './App.css';
import './components/desktopVersion.css'
import './components/mobileVersion.css'
// import '../src/components/'

// import './components/mobileVersion.css'
import {BrowserRouter, Routes, Route} from 'react-router-dom'

import Home from './components/Home';
import About from './components/About';
import Blogs from './components/Blogs';
import BlogPost from './components/blogs/BlogPost';
import BlogPostTwo from './components/blogs/BlogPostTwo'
import BlogPostThree from './components/blogs/BlogPostThree';

import Careers from './components/Careers';
import Services from './components/Services';
import Contact from './components/Contact';
// import Header from './components/Header';
import SideNav from './components/SideNav';
// sub pages of services page...
import SocialMediaMarketing from "./components/services/SocialMediaMarketing";
import PayPerClickAds from "./components/services/PayPerClickAds";
import WebsiteDesigning from "./components/services/WebsiteDesigning";
import WhatsAppMarketing from "./components/services/WhatsAppMarketing";
import BulkSMS from "./components/services/BulkSMS";
import VideoAds from './components/services/VideoAds';
import SearchEngineOptimization from "./components/services/SearchEngineOptimization";
import EmailMarketing from "./components/services/EmailMarketing";
import InfluencerMarketing from "./components/services/InfluencerMarketing";

import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import Disclaimer from './components/Disclaimer';

// Header Two
import HeaderTwo from './components/HeaderTwo';


<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />

function App() {

  return (
    <div className="App">
      <BrowserRouter>
      {/* <Header/> */}
      <HeaderTwo/>
      <SideNav/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/services' element={<Services/>}></Route>
          <Route path='/blog' element={<Blogs/>}/>
          <Route path='/blog-post' element={<BlogPost/>} />
          <Route path='/blog-post-two' element={<BlogPostTwo/>} />
          <Route path='/blog-post-three' element={<BlogPostThree/>} />
          <Route path='/services/socialmediamarketing' element={<SocialMediaMarketing/>}/>
          <Route path='/services/payperclickads' element={<PayPerClickAds/>}/>
          <Route path='/services/websitedesigning' element={<WebsiteDesigning/>}/>
          <Route path='/services/whatsappmarketing' element={<WhatsAppMarketing/>}/>
          <Route path='/services/bulksms' element={<BulkSMS/>}/>
          <Route path='/services/videoads' element={<VideoAds/>}/>
          <Route path='/services/searchengineoptimization' element={<SearchEngineOptimization/>}/>
          <Route path='/services/emailmarketing' element={<EmailMarketing/>}/>
          <Route path='/services/influencermarketing' element={<InfluencerMarketing/>}/>
          <Route path='/about' element={<About/>}/>
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/careers' element={<Careers/>}/>
          <Route path='/privacypolicy' element={<PrivacyPolicy/>}/>
          <Route path='/disclaimer' element={<Disclaimer/>}/>
        </Routes>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
